var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9683 8.7294C17.8943 8.41456 17.6521 8.14797 17.3524 8.0483C17.0048 7.93281 16.6815 8.02378 16.3803 8.32833C15.4208 9.2958 14.4628 10.2609 13.5033 11.2276L10.9629 13.785L9.8885 12.7052C9.44255 12.2567 8.99582 11.809 8.55066 11.3597C8.30999 11.1184 8.03707 11.029 7.75079 11.0954C7.38664 11.1785 7.13653 11.4119 7.03035 11.7694C6.93125 12.0961 7.02563 12.407 7.30798 12.6918L10.3053 15.7026C10.5004 15.8972 10.7316 16 10.9762 16C11.2216 16 11.456 15.8956 11.6518 15.6986C11.9137 15.4368 12.1717 15.1749 12.4305 14.9115L14.0397 13.2843C15.265 12.0439 16.4896 10.8036 17.7174 9.56792C17.9494 9.33456 18.0398 9.03079 17.9683 8.7294Z",
    fill: "#4AC600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickicon);
export default __webpack_public_path__ + "static/media/tickicon.bf12e78f.svg";
export { ForwardRef as ReactComponent };